<template>
    <div class="page-table  mainDiv " id="affix-container">
        <el-col :span="24" class="animated fadeInUp">
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="haberTanimlama"> Haber Tanımlama
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="haberListDetay"> Haber Listesi
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="haberKisaList"> Haber Kısa Listesi
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="haberCount"> Haber count
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="haberDetay"> Haber Detay
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="haberDurumGuncelle"> Haber Durum Güncelle
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="haberGuncelle"> Haber Guncelle
            </el-button>
        </el-col>
    </div>
</template>

<script>
    import haberService from '../../../WSProvider/HaberService';
    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userData5B = "";
    export default {
        name: "HaberDetay",
        methods: {
            haberTanimlama() {
                haberService.haberTanimlama("test haber", "HK-1000", "Test Haber", "", "deneme içerik", "Seo Baslik", "seo Içerik haber", ["resim", "resim2"], 1, 1, 1, "2020-06-09", "2020-06-25", 1);
            },
            haberKisaList() {
                haberService.haberKisaList("HK-1000", 20);
            },
            haberDurumGuncelle() {
                haberService.haberDurumGuncelle("HB-1000", 0);
            },
            haberListDetay() {
                haberService.haberListDetay("HK-1000", 0, 10, 1);
            },
            haberCount() {
                haberService.haberCount(1);
            },
            haberDetay() {
                haberService.haberDetay("HB-1000");
            },
            haberGuncelle() {
                let updateList = [{
                    type: "baslik",
                    value: "tes354t"
                }, {
                    type: "resim",
                    value: [{
                        durum : 2,
                        resim : "anaresim"
                    }, {
                        durum :0,
                        resim:"resim2"
                    }, {
                        durum :1,
                        resim:"resim25"
                    }]
                }];
                haberService.haberGuncelle("HB-1000", updateList);
            },

        }
    }
</script>

<style scoped>

</style>